<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <p>{{data.message}}</p>
  
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Buscar cadete</mat-label>
    <input matInput [formControl]="searchControl" placeholder="Buscar por nombre o teléfono">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="cadet-list">
    <mat-selection-list>
      <mat-list-option 
        *ngFor="let cadet of filteredCadets" 
        [selected]="selectedCadet?.cdDelivery === cadet.cdDelivery"
        (click)="selectCadet(cadet)"
      >
        <div class="cadet-item">
          <div class="cadet-name">{{ cadet.dsName || 'Sin nombre' }}</div>
          <div class="cadet-phone">{{ cadet.dsPhone || 'Sin teléfono' }}</div>
        </div>
      </mat-list-option>
      
      <div *ngIf="filteredCadets.length === 0" class="no-results">
        No se encontraron cadetes que coincidan con la búsqueda
      </div>
    </mat-selection-list>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{data.cancelButtonText}}</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="onConfirm()"
    [disabled]="!selectedCadet"
  >
    {{data.confirmButtonText}}
  </button>
</mat-dialog-actions>
